import { render, staticRenderFns } from "./SocialNetworksStep.vue?vue&type=template&id=5809cf22"
import script from "./SocialNetworksStep.vue?vue&type=script&lang=js"
export * from "./SocialNetworksStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports